import { inject } from 'vue';

export const useDayjs = () => inject('Dayjs');
2;
